const deburrObject = (o: any) => {
  const obj = {
    ...o,
    ...o.attributes,
    ...o.relationships,
  };

  delete obj.attributes;
  delete obj.relationships;
  delete obj.links;

  return obj;
};

/* eslint-disable-next-line */
export { deburrObject };
